<template>
  <div>
    <div class="policy">
      <h1>{{getLegalAdvise.title}}</h1>
      <h2 class="cookies-subtitle">{{getLegalAdvise.sub1}}</h2>
      <p class="cookies-info">{{getLegalAdvise.p1}}</p>
      <p class="cookies-info">{{getLegalAdvise.p2}}</p>
      <p class="cookies-info">{{getLegalAdvise.p3}}</p>
      <p>{{getLegalAdvise.p4}}</p>
      <h2 class="cookies-subtitle">{{getLegalAdvise.sub2}}</h2>
      <p class="cookies-info">{{getLegalAdvise.p5}}</p>
      <p class="cookies-info">{{getLegalAdvise.p6}}</p>
      <p class="cookies-info">{{getLegalAdvise.p7}}</p>
      <p class="cookies-info">{{getLegalAdvise.p8}}</p>
      <p class="cookies-info">{{getLegalAdvise.p10}}</p>
      <p class="cookies-info">{{getLegalAdvise.p11}}</p>
      <h2 class="cookies-subtitle">{{getLegalAdvise.sub3}}</h2>
      <p class="cookies-info">{{getLegalAdvise.p12}}</p>
      <p class="cookies-info">{{getLegalAdvise.p13}}</p>
      <p class="cookies-info">{{getLegalAdvise.p14}}</p>
      <p class="cookies-info">{{getLegalAdvise.p15}}</p>
      <h2 class="cookies-subtitle">{{getLegalAdvise.sub4}}</h2>
      <p class="cookies-info">{{getLegalAdvise.p17}}</p>
      <p class="cookies-info">{{getLegalAdvise.p18}}</p>
      <h2 class="cookies-subtitle">{{getLegalAdvise.sub5}}</h2>
      <p class="cookies-info">{{getLegalAdvise.p19}}</p>
      <p class="cookies-info">{{getLegalAdvise.p20}}</p>
      <p class="cookies-info">{{getLegalAdvise.p21}}</p>
      <p class="cookies-info">{{getLegalAdvise.p22}}</p>
      <p class="cookies-info">{{getLegalAdvise.p23}}<a href="mailto:privacidad@damm.com">privacidad@damm.com</a></p>
      <p class="cookies-info">{{getLegalAdvise.p24}}</p>
      <h2 class="cookies-subtitle">{{getLegalAdvise.sub6}}</h2>
      <p class="cookies-info">{{getLegalAdvise.p25}}</p>
      <p class="cookies-info">{{getLegalAdvise.p26}}</p>
      <p class="cookies-info">{{getLegalAdvise.p27}}<a href="https://www.damm.com/es/faqs" target="_blank" rel="noopener noreferrer">www.damm.com/es/faqs</a></p>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import router from '@/router/index.js'
import ApiService from '@/services/ApiService'
import LocalStorageService from '@/services/LocalStorageService'

export default {
  name: 'CookiesPolicy',
  computed: {
    ...mapGetters(['getLegalAdvise'])
  },
  methods: {
    ...mapMutations(['changeLoading', 'setCodeLangs', 'setConfig', 'setTranslationsAPI', 'setEmail', 'setIsAdult']),
    async getContest (params) {
      this.changeLoading(true)
      try {
        const response = await ApiService.getAvailableContest(params)
        const responseData = response.data.data
        if (response.data.code === 200) {
          this.setCodeLangs(responseData.contest.code_langs)
          this.setConfig(responseData.contest.template_config)
          this.setTranslationsAPI(responseData.contest.cms_translation)
          document.documentElement.style.setProperty('--primary', responseData.contest.template_config.brand_color)
          document.documentElement.style.setProperty('--star', responseData.contest.template_config.star_color)
          this.setEmail(LocalStorageService.getParsed('userEmail'))
          if (LocalStorageService.ifTrue('isAdult')) {
            this.setIsAdult(true)
          }
          this.changeLoading(false)
        } else {
          router.push({ path: '/' })
          this.changeLoading(false)
        }
      } catch (error) {
        this.changeLoading(false)
        router.push({ path: '/' })
      }
    }
  },
  created () {
    const params = {
      alias_url: this.$route.params.alias_url,
      preview: this.$route.params.preview === 'preview' ? this.$route.params.preview : ''
    }
    this.getContest(params)
  }
}
</script>

<style scoped>
.policy {
  max-height: 100%;
  min-height: 100vh;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: 5.5rem;
  padding-bottom: 5.5rem;
  overflow-wrap: break-word;
}
@media (min-width: 768px) {
  .policy {
    padding-left: 5rem;
    padding-right: 5rem;
  }
}
h1 {
  font-weight: 700;
  font-size: 1.125rem;
  line-height: 1.75rem;
  margin-bottom: 1rem;
  text-align: center;
}
h2 {
  font-weight: 700;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
p {
  font-size: 0.875rem;
  line-height: 1.25rem;
  margin-top: 0.5rem;
}
ul {
  padding-left: 0.5rem;
}
li {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
a {
  -webkit-text-decoration-line: underline;
  text-decoration-line: underline;
}
</style>
